import EmailField from './EmailField'
import ProvinceField from './ProvinceField'
import PhoneField from './PhoneField'
import ContactField from './ContactField'
import CompanyNameField from './CompanyNameField'
import EmployeesField from './EmployeesField'
import AcceptConditionsField from './AcceptConditionsField'
import KnowUsField from './KnowUsField'
import AddressField from './AddressField'
import NameField from './NameField'
import FleetNameField from './FleetNameField'
import FleetNumberField from './FleetNumberField'
import ParkingNameField from './ParkingNameField'
import ParkingLotsNumberField from './ParkingLotsNumberField'

export default {
    email: EmailField,
    province: ProvinceField,
    phone: PhoneField,
    contact: ContactField,
    companyName: CompanyNameField,
    employees: EmployeesField,
    acceptConditions: AcceptConditionsField,
    knowUs: KnowUsField,
    address: AddressField,
    name: NameField,
    fleetName: FleetNameField,
    fleetNumber: FleetNumberField,
    parkingName: ParkingNameField,
    parkingLotsNumber: ParkingLotsNumberField,
}
